export const DashboardSteps = [
  {
    disableBeacon: true,
    target: "[data-tour-target='menu']",
    content:
      "ActionHub is about tracking your work and sharing your progress with your team. The tools here help you track your resources, actions, strategies, goals, and more.",
  },
];
